import getCellIdentity from './getCellIdentity';
import { checkboxInTable } from './handleSpecialCase';
import { keyByModuleId } from '../createKeyMap';
import { MODULE_TYPE } from '../config/moduleType';
import { config as CONFIG } from '@platform/api'
import { findParentTd } from '@platform/api';
import { executeAutoFocus } from './findNextFocusItemInTable';
import { findLastFocusItemInForm } from './findNextFocusItemInForm';


/**
 * @desc 查找下一个可聚焦元素
 * @param target {dom} 事件源
 * @param ViewModel {object} 全局变量
 * @param moduleId {string} 当前区域Id
 * @param orderOfHotKey {array} 区域显示顺序配置
 */
function findPrevFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey }) {
    var parentTd = eventTarget.tagName === 'TD' ? eventTarget : findParentTd(eventTarget);
    if (!parentTd) {
        // 这里报错的原因是因为某些事件（下拉的keydown）执行了两次
        console.warn('not find parentTd, prev hotkey invalid');
        return;
    }
    var prevTd = parentTd.previousElementSibling;
    var currentTr = parentTd.parentElement;
    var firstTd = findFirstTdInRow(currentTr);
    var div = prevTd && prevTd.querySelector('[tabindex="0"]');

    //如果是第一一个元素就需要判断跳到上一行还是跳到上一个区域
    if (firstTd === parentTd) {
        var lastTr = currentTr.parentElement.lastElementChild;

        currentTr === lastTr
            ? perceptionHotKeyConfig({ currentModuleId: moduleId, ViewModel, orderOfHotKey })
            : findPrevRowTd({ tr: currentTr, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    // 如果下一个元素没有找到就继续查找
    if (div === null || checkboxInTable(div)) {
        findPrevSiblings({ td: prevTd, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    // 解决table 设值后重新渲染导致焦点缺失的问题,在这里保留一下id
    let cellIdentity = getCellIdentity(prevTd);
    cellIdentity
        ? ViewModel.enterTriggerCellId = cellIdentity
        : '';
    executeAutoFocus({ div, ViewModel });
}

/**
 * @desc 查找当前行里的第一个td，需要排除操作列
 * @param tr {dom}
 * @return td {dom}
 */
function findFirstTdInRow(tr) {
    let tds = tr.querySelectorAll('td');

    let td = Array.prototype.find.call(tds, function (td) {
        return !td.className.includes('fixed');
    });

    return td;
}

/**
 * @desc 判断业务组是否配置快捷键，如果没有就在本区域内循环 反之根据orderOfHotKey跳转上个区域
 * @param currentModuleId {string} 当前的区域ID
 * @param ViewModel 全局变量
 * @param orderOfHotKey {array} 区域展示顺序
 */
function perceptionHotKeyConfig({ currentModuleId, ViewModel, orderOfHotKey }) {
    if (orderOfHotKey && orderOfHotKey.length === 0) {
        findLastFocusItemInCurrentModule({ currentModuleId, ViewModel });
    } else {
        orderOfHotKey &&
            jumpToPrevModuleFocusItem({ currentModuleId, ViewModel, orderOfHotKey });
    }
}

function findLastFocusItemInCurrentModule({ currentModuleId, ViewModel }) {
    let id = `${CONFIG.hotKeyModuleIdPrefix}-${currentModuleId}`;
    let tableTr = document.querySelectorAll(`#${id} table tbody tr.u-table-row`);
    let lastOneIndex = tableTr[tableTr.length - 1];
    let tds = tableTr[lastOneIndex].querySelectorAll('td');

    let lastFocusItem = findLastChild(tds);

    let cellIdentity = getCellIdentity(lastFocusItem);
    cellIdentity
        ? ViewModel.enterTriggerCellId = cellIdentity
        : '';

    var div = lastFocusItem.querySelector('[tabindex="0"]');
    div && executeAutoFocus({ div, ViewModel });
}

/**
 * @desc 寻找最后一个可编辑啊元素
 * @param tds {nodeList}
 */
function findLastChild(tds) {
    // eslint-disable-next-line no-empty
    for (var i = tds.length; i > -1; i--) {
        if (tds[i].querySelector('[tabindex="0"]') !== null) {
            return tds[i];
        }
    }
}


function jumpToPrevModuleFocusItem({ currentModuleId, ViewModel, orderOfHotKey }) {
    let prevModuleId = calculatePrevModuleId(currentModuleId, orderOfHotKey);

    let prevModuleKeyMap = keyByModuleId[prevModuleId];

    if (prevModuleKeyMap === undefined) return;

    let type = prevModuleKeyMap.type;
    if (type === MODULE_TYPE.cardTable || type === MODULE_TYPE.editTable) {
        //如果是table类型就获取当前table显示的页签
        let activeTableKeyMap = keyByModuleId[prevModuleKeyMap.activeTable];
        let lastItemDom = document.querySelector(`div[${activeTableKeyMap.lastItem}]`);
        let div = lastItemDom.querySelector('[tabindex="0"]');

        if (div === null) {
            let td = lastItemDom.parentElement;
            findPrevSiblings({ td, ViewModel, moduleId: activeTableKeyMap.moduleId, orderOfHotKey });
        } else {
            let td = findParentTd(div);

            /**
             * @desc 表格编辑后会导致页面重新渲染导致聚焦状态丢失，因此enter键跳转的需要在全局记录一下，为操作的连续性渲染完成后重新聚焦做标识
             * @type {string}
             */
            let cellIdentity = getCellIdentity(td);
            cellIdentity
                ? ViewModel.enterTriggerCellId = cellIdentity
                : '';
            executeAutoFocus({ div, ViewModel });
        }

    } else {
        findLastFocusItemInForm(prevModuleKeyMap, prevModuleId);
    }
}

/**
 * @desc 递归查找上一个可聚焦元素
 * @param td {dom} 前一个td
 * @param ViewModel {object} 全局变量
 * @param moduleId {string} 当前区域的Id
 * @param orderOfHotKey
 */
function findPrevSiblings({ td, ViewModel, moduleId, orderOfHotKey }) {
    var prevTd = td.previousElementSibling;
    var currentTr = prevTd && prevTd.parentElement;
    var firstTd = currentTr && findFirstTdInRow(currentTr);
    var currentDiv = td.querySelector('[tabindex="0"]');
    var div = prevTd && prevTd.querySelector('[tabindex="0"]');

    //如果下个需要聚焦的单元格与最后一个单元相同并且没有可聚焦元素就在下一行查找
    if ((firstTd === prevTd && div === null) || (firstTd === td && currentDiv === null)) {
        findPrevRowTd({ tr: currentTr, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    if (div === null || checkboxInTable(div)) {
        findPrevSiblings({ td: prevTd, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    let cellIdentity = getCellIdentity(prevTd);
    cellIdentity
        ? ViewModel.enterTriggerCellId = cellIdentity
        : '';
    executeAutoFocus({ div, ViewModel });
}

function calculatePrevModuleId(currentModuleId, orderOfHotKey) {
    let orderOfHotKeyLen = orderOfHotKey.length;
    let currentModuleIndex = orderOfHotKey.indexOf(currentModuleId);

    let prevModuleIndex = currentModuleIndex - 1 < -1
        ? orderOfHotKey[orderOfHotKeyLen - 1]
        : currentModuleIndex - 1;
    return orderOfHotKey[prevModuleIndex];
}

//查找上一行可聚焦元素
function findPrevRowTd({ tr, ViewModel, moduleId, orderOfHotKey }) {
    var prevTr = tr && tr.previousElementSibling;

    //如果是最后一行就查找下个区域的第一个可聚焦元素
    if (prevTr === null) {
        orderOfHotKey &&
            jumpToPrevModuleFocusItem({ currentModuleId: moduleId, ViewModel, orderOfHotKey });
        return;
    }

    if (prevTr.getAttribute('tabindex') === '-1') {
        findPrevRowTd({ tr: prevTr, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    var divs = prevTr.querySelectorAll('td [tabindex="0"]');
    var lastDiv = divs[divs.length - 1];
    var td = findParentTd(lastDiv);

    let cellIdentity = getCellIdentity(td);
    cellIdentity
        ? ViewModel.enterTriggerCellId = cellIdentity
        : '';
    executeAutoFocus({ div: lastDiv, ViewModel });
}


export {
    findPrevFocusItemInTable,
};
